import { useEffect, useState } from "react";
import api from "../lib/api";
import { Spinner, EmptyState } from "../components/states";
import { BackButton, Breadcrumbs, ExternalLink, useEscape } from "../lib/nav";

export default function Picks() {
  const [picks, setPicks] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/picks").then((r) => { setPicks(r.data); setLoading(false); }).catch(() => setLoading(false)); }, []);
  if (loading) return <Spinner />;
  return (
    <div className="mx-auto max-w-[1600px] px-4 sm:px-6 py-8">
      <div className="flex items-center gap-4 flex-wrap mb-4"><BackButton fallback="/" /><Breadcrumbs items={[{ label: "Live", to: "/" }, { label: "Picks" }]} /></div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight">Picks & Showcases</h1>
      <p className="mono-label text-[#71717A] mt-2">CURATED SELECTIONS FROM OUR RESIDENTS</p>
      {picks.length === 0 ? <EmptyState title="No picks yet" /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {picks.map((p, i) => (
            <div key={p.id} data-testid={`pick-${p.id}`} className="card-copper rounded-xl overflow-hidden fade-up" style={{ animationDelay: `${i * 0.05}s` }}>
              <div className="aspect-square overflow-hidden bg-[#1A1A22]"><img src={p.image} alt={p.curator} className="w-full h-full object-cover" /></div>
              <div className="p-5">
                <span className="mono-label text-[#E8552A]">PICKS #{p.number}</span>
                <p className="font-display text-xl font-bold mt-1">{p.curator}</p>
                <p className="text-sm text-[#A1A1AA] mt-2 italic">"{p.quote}"</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
